"use client";

import getGameContainer, {
  GAME_CONTAINER_ID,
} from "@casino/ui/Games/getGameContainer";
import { useGamePageData } from "@casino/ui/Games/hooks";
import { GameControlsMute } from "@workspace/frontend-ui";
import type { FC } from "react";
import { useEffect, useState } from "react";

const MUTE_STORAGE_KEY = "desktopGameMuted";

const MuteButton: FC = () => {
  const { t } = useGamePageData();
  const [isMuted, setIsMuted] = useState(false);

  useEffect(() => {
    setIsMuted(localStorage.getItem(MUTE_STORAGE_KEY) === "true");
  }, []);

  useEffect(() => {
    const applyMute = () =>
      getGameContainer()?.setAttribute("mute", String(isMuted));
    applyMute();

    const wrapper = document.getElementById(GAME_CONTAINER_ID);
    wrapper?.addEventListener("game-ready", applyMute);
    return () => wrapper?.removeEventListener("game-ready", applyMute);
  }, [isMuted]);

  const handleToggleMute = () => {
    const next = !isMuted;
    localStorage.setItem(MUTE_STORAGE_KEY, String(next));
    setIsMuted(next);
  };

  const label = isMuted
    ? t("game.controls.mute.unmute", "Unmute the game")
    : t("game.controls.mute.mute", "Mute the game");

  return (
    <GameControlsMute
      data-testid="mute-button"
      aria-label={label}
      isMuted={isMuted}
      onClick={handleToggleMute}
    />
  );
};

export default MuteButton;
